import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Roles API service
 */
export const RoleApi = {
  /**
   * Get all roles (Admin only)
   * @returns {Promise<Response>} All roles response
   */
  getRoles: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/roles`, {
      method: 'GET',
    });
  },

  /**
   * Create role (Admin only)
   * @param {Object} data - Role data
   * @returns {Promise<Response>} Create response
   */
  createRole: async (data) => {
    // FIXED: Ensure we're using the correct field name
    const formattedData = {
      roleName: data.roleName || data.role_name
    };
    
    console.log('RoleApi.createRole: Sending data:', formattedData);
    
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/roles`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formattedData),
    });
  },

  /**
   * Update role (Admin only)
   * @param {string|number} id - Role ID
   * @param {Object} data - Updated role data
   * @returns {Promise<Response>} Update response
   */
  updateRole: async (id, data) => {
    // FIXED: Ensure we're using the correct field name
    const formattedData = {
      roleName: data.roleName || data.role_name
    };
    
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/roles/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formattedData),
    });
  },

  /**
   * Delete role (Admin only)
   * @param {string|number} id - Role ID
   * @returns {Promise<Response>} Delete response
   */
  deleteRole: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/roles/${id}`, {
      method: 'DELETE',
    });
  },

  /**
   * Get roles assigned to a specific user
   * @param {string|number} userId - User ID
   * @returns {Promise<Response>} User roles response
   */
  getUserRoles: async (userId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/${userId}/roles`, {
      method: 'GET',
    });
  },

  /**
   * Assign role to user
   * @param {string|number} userId - User ID
   * @param {string|number} roleId - Role ID
   * @returns {Promise<Response>} Assignment response
   */
  assignRoleToUser: async (userId, roleId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/${userId}/roles/${roleId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({}), // Empty body for POST
    });
  },

  /**
   * Remove role from user
   * @param {string|number} userId - User ID
   * @param {string|number} roleId - Role ID
   * @returns {Promise<Response>} Removal response
   */
  removeRoleFromUser: async (userId, roleId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/${userId}/roles/${roleId}`, {
      method: 'DELETE',
    });
  },
};